/* src/app/about/about.component.scss */
.header {
  padding: 70px 0;
}
/*# sourceMappingURL=about.component.css.map */
